module.exports = __webpack_public_path__ + "img/world.6ef2490e.svg";